import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { LocalStorageService } from './services/utils/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { OperatorService } from './services/resources/operator.service';
import { PwaService } from './services/utils/pwa.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LbTranslationService } from '@affluences/lb-utils-front';
import { ColorPaletteService } from './services/utils/color-palette.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    private installedLaunched: boolean = false
    isConnected: boolean = true
    viewport: Element
    initialHeight: number
    initialWidth: number

    deferredPWAPrompt: Event;

    constructor(
        @Inject(L10N_LOCALE) public locale: L10nLocale,
        private localStorageService: LocalStorageService,
        private router: Router,
        private route: ActivatedRoute,
        private _snackBar: MatSnackBar,
        private lbTranslationService: LbTranslationService,
        private operatorService: OperatorService,
        private pwaService: PwaService
    ) {


        this.localStorageService.checkLanguage()

        this.pwaService.$installEvent.subscribe((event) => {

            const noInstall = this.route.snapshot.queryParams['noInstall']

            if (!this.installedLaunched && !noInstall && event) {
                const promptEvent: any = event
                const snackBarRef = this._snackBar.open(
                    this.lbTranslationService.translateFromKey('endpoint_global_install_text', { lang: this.locale.language }),
                    this.lbTranslationService.translateFromKey('endpoint_global_install_button', { lang: this.locale.language }),
                    { duration: 5000, verticalPosition: 'top' }
                )

                snackBarRef.onAction().subscribe(() => {
                    this.installedLaunched = true
                    promptEvent.prompt()
                })
            }
        })
    }

    @HostListener('window:focus', ['$event'])
    onFocus(event) {
        this.operatorService.onFocus()
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
        if (window.innerWidth === this.initialWidth && window.innerHeight < this.initialHeight) {    // KEYBOARD DISPLAYED
            this.viewport.setAttribute('content', 'height=' + this.initialHeight + ', width=device-width, initial-scale=1')
        } else if (window.innerWidth !== this.initialWidth) {       // OTHER CASES
            this.viewport.setAttribute("content", "width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no")
            this.updateViewportSize()
        }
    }

    ngOnInit() {
        this.operatorService.init()
        const applicationId = this.localStorageService.getApplicationId()
        if (applicationId) {
            this.pwaService.changeManifest(applicationId)
        }

        this.updateViewportSize()
        this.viewport = document.querySelector("meta[name=viewport]");
        this.viewport.setAttribute("content", "width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no")
    }

    updateViewportSize(): void {
        this.initialHeight = window.innerHeight
        this.initialWidth = window.innerWidth
    }
}
